'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { UpsellBannerRootContext } from './context/upsell-banner-root.context';
import { upsellBannerHeaderRecipe } from './styles/upsell-banner-header.styles';
import type { UpsellBannerHeaderPropsInterface } from './types/upsell-banner-header.types';

/**
 * @since 10.0.0
 */
export const UpsellBannerHeader = forwardRef<HTMLDivElement, UpsellBannerHeaderPropsInterface>(
  (props: UpsellBannerHeaderPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const { tone } = useContext(UpsellBannerRootContext);
    const styles = css(upsellBannerHeaderRecipe.raw({ tone }), cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="UpsellBanner.Header"
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

UpsellBannerHeader.displayName = 'UpsellBanner.Header';
